export enum CreditCardServiceEnum {
    None = 0,
    FirstData = 1,
    Pinnacle = 2,
    Stripe = 3
}